import React, { createContext, useContext } from 'react';

interface SidebarContextType {
  toggleSidebar: () => void;
}

const SidebarContext = createContext<SidebarContextType>({ toggleSidebar: () => {} });

export const SidebarProvider = SidebarContext.Provider;

export const useSidebar = () => useContext(SidebarContext);
